import { Component, OnDestroy, OnInit } from '@angular/core'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { take } from 'rxjs/operators'
import {
  ICON_TYPE,
  ViewModes,
  PageLayoutService,
  ViewConfig,
} from '@spartacus/storefront'
import { ActivatedRoute, Router } from '@angular/router'
import { ProductListComponentService } from './product-list-component.service'
import { SearchBoxComponentService } from '../../search-box/search-box-component.service'
import { CommonService } from '../../../shared/services/common.service'
import { ProductSearchPage } from '../../../models/product-search.model'
import {
  Ecommerce,
  GTMDataLayer,
} from '../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../shared/services/gtm.service';

@Component({
  standalone: false,
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit, OnDestroy {
  private subscription = new Subscription()
  iconTypes = ICON_TYPE
  isInfiniteScroll: boolean
  itemsPerPage = 50
  model$: Observable<ProductSearchPage> =
    this.productListComponentService.model$
  model1$: Observable<ProductSearchPage> =
    this.productListComponentService.model$
  model: any
  ViewModes = ViewModes
  mode = ViewModes.Grid
  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid)
  params: any
  currentPageNumber = 0
  sortCode = 'relevance'
  queryParams: any
  routeFrom = ItemListTypeEnum.ProductListing;
  productListData: any[] = [];
  listViewSelected: boolean = false;

  constructor(
    private pageLayoutService: PageLayoutService,
    private productListComponentService: ProductListComponentService,
    public scrollConfig: ViewConfig,
    public commonService: CommonService,
    public routes: ActivatedRoute,
    public router: Router,
    private globalMessageService: GlobalMessageService,
    private searchBoxComponentService: SearchBoxComponentService,
    private gtmService: GoogleTagManagerService
  ) {
    if (sessionStorage.getItem('mode')) {
      this.mode = sessionStorage.getItem('mode') as ViewModes
    }
    this.routes.params.subscribe((success) => {
      this.params = success
    })
    this.routes.queryParams.subscribe((success) => {
      this.queryParams = success
      this.currentPageNumber = this.queryParams?.currentPage || 0
      this.itemsPerPage = this.queryParams?.pageSize || 50
    })
  }

  ngOnInit(): void {
    this.productListComponentService.getDefaultPage.subscribe((value) => {
      this.itemsPerPage = value
    })
    this.isInfiniteScroll = this.scrollConfig.view.infiniteScroll.active
    this.subscription.add(
      this.pageLayoutService.templateName$.pipe(take(1)).subscribe(
        (template) => {
          this.viewMode$.next(this.mode)
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    )

    this.model1$.subscribe((res) => {
      this.productListData = res.products || [];
      this.listViewSelected = (this.mode === ViewModes.List && this.productListData.length == 1) ? true : false;
      this.pushAddToCartEvent(res.products);
    });

    this.searchBoxComponentService.inSearchFlowOnly.next(false)
  }

  pushAddToCartEvent(productList: any[]) {
    const item: Ecommerce = {
      item_list_id: this.routeFrom,
      item_list_name: this.routeFrom,
      items: productList.map((product, index) => {
        return {
          item_id: product?.code,
          item_name: product?.name,
          coupon: '',
          discount: product?.discountPercentage
            ? Number(product?.discountPercentage)
            : '',
          index: index,
          item_category: '',
          item_category2: '',
          item_category3: '',
          item_category4: '',
          item_category5: '',
          item_list_id: this.routeFrom,
          item_list_name: this.routeFrom,
          price: product?.yourPrice?.value || '',
          quantity: 1,
        };
      }),
    };

    const eventData: GTMDataLayer = {
      event: GtmEvents.ViewItemList,
      ecommerce: item,
    };
    this.gtmService.sendEvent(eventData);
  }

  sortList(sortCode: string): void {
    this.productListComponentService.sort(sortCode, this.routes)
    this.productListComponentService.setSortCode(sortCode)
    this.sortCode = sortCode
    if (this.queryParams) {
      this.currentPageNumber = this.queryParams?.currentPage
    }
    if (this.currentPageNumber > 0) {
      this.productListComponentService.route(
        {
          sortCode: sortCode,
          currentPage: 0,
        }, 
        this.routes
      );
    }
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
    this.mode = mode;
    this.listViewSelected = (this.mode === ViewModes.List && this.productListData.length == 1) ? true : false;
    this.routes.queryParams.subscribe(
      (params: any) => {
        if (params.currentPage !== undefined) {
          this.currentPageNumber = params.currentPage
        }
        this.searchProduct(this.params.query, this.itemsPerPage)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  getValue(event) {
    this.itemsPerPage = event
    this.currentPageNumber = 0
    this.productListComponentService.pageChange(this.itemsPerPage, this.routes)
    this.productListComponentService.setPagetoDefault(this.itemsPerPage)
    this.productListComponentService.changeDefaultPageSize(this.itemsPerPage)
    // this.searchProduct(this.params.query, this.itemsPerPage);
    this.productListComponentService.route({ currentPage: 0, pageSize: event }, this.routes)
  }

  searchProduct(key, pagesize) {
    const keys = Object.keys(this.params)
    const len = keys.length
  }

  currentPage(event) {
    this.currentPageNumber = event
    this.productListComponentService.route(
      {
        currentPage: event,
        pageSize: this.itemsPerPage,
      },
      this.routes
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
